import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const LockPromptIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="16" height="16" rx="8" fill={fillColor || 'black'} />
      <rect x="4.5" y="7.5" width="7" height="5" rx="1.5" stroke="#9D9DA6" />
      <path d="M10 5V5C10 3.89543 9.10457 3 8 3V3C6.89543 3 6 3.89543 6 5V8" stroke={fillColor || '#9D9DA6'} />
    </svg>
  );
};

export { LockPromptIcon };
